var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSketch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06817 2.99386L9.99998 2.5L14.9318 2.99386L18.75 7.84875L9.99998 17.4999L1.25 7.84875L5.06817 2.99386Z",
    fill: "#FDB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79414 7.84863L9.99994 17.4999L1.25 7.84863H4.79414ZM15.2059 7.84863L10.0001 17.4999L18.75 7.84863",
    fill: "#EA6C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79395 7.84863H15.2055L9.99974 17.4999",
    fill: "#FDAD00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99974 2.5L5.06793 2.99378L4.79395 7.8487L9.99974 2.5ZM9.99982 2.5L14.9316 2.99378L15.2056 7.8487",
    fill: "#FDD231"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.84858L14.9319 2.99365L15.2059 7.84858H18.75ZM1.25 7.84858L5.06813 2.99365L4.79414 7.84858",
    fill: "#FDAD00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99974 2.5L4.79395 7.8487H15.2055",
    fill: "#FEEEB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.f173e7a1365c21fe78517df50fcfa7f4.svg";
export { ForwardRef as ReactComponent };